import { Document } from "react-pdf";
import { Button, Dialog, DialogContent, DialogActions } from "@mui/material";
import { styled } from "@mui/system";

import { ConfirmDialog } from "../../../../components/Modals";

export const StyledStakeholderTermsAndConditions = styled("div")(({ theme }) => ({
  maxWidth: theme.constants.containerWidth,
  width: "inherit",
  "& .mainTitle": {
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    fontFamily: "Rakbank Sans",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: 500,
    letterSpacing: "normal",
    fontStretch: "normal",
    lineHeight: "0.25rem"
  },
  "& .kfsSubTitle": {
    fontWeight: 400,
    fontSize: "20px",
    color: "#757575",
    margin: 0,
    marginBottom: "40px"
  },
  "& .descriptionContent": {
    background: "#FFFFFF",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    marginBottom: "20px",
    border: "1px solid #E6E6E6",
    [theme.breakpoints.up("sm")]: {
      padding: "18px"
    }
  },
  "& .kfsDescriptionContent": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px"
  },
  "& .kfsTitle": {
    margin: "0px",
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "24px",
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
  },
  "& .completedWrapper": {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "32px",
    minWidth: "90px",
    background: "#ECF9F2",
    borderRadius: "10px",
    fontSize: "12px",
    color: "#157947",
    fontWeight: 500,
    [theme.breakpoints.up("sm")]: {
      minWidth: "98px"
    }
  },
  "& .notAcceptWrapper": {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "32px",
    width: "20%",
    background: "#FDE7E8",
    borderRadius: "10px",
    fontSize: "12px",
    color: "#8D0C10",
    fontWeight: "500"
  },
  "& .authorisationsList": {
    padding: "16px",
    fontWeight: "400",
    fontSize: "14px",
    margin: "0px",
    color: "#757575",
    "& li": {
      marginBottom: "4px"
    },
    [theme.breakpoints.up("sm")]: {
      padding: "unset",
      paddingLeft: "24px"
    }
  }
}));

export const StyledTermsAndConditionsBtn = styled(Button)(({ theme }) => ({
  fontFamily: "Rakbank Sans",
  height: "3.2rem",
  width: "16rem",
  borderRadius: "100px",
  fontWeight: 600,
  fontSize: "14px",
  letterSpacing: "0px",
  textTransform: "none",
  padding: "19px 24px",
  marginTop: "20px",
  alignSelf: "center",
  "&.readBtn": {
    border: "1px solid #1F1F1F",
    background: "transparent",
    lineHeight: "22px",
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    [theme.breakpoints.up("sm")]: {
      borderRadius: "21px",
      padding: "9px 24px",
      width: "124px",
      height: "40px",
      alignSelf: "unset"
    }
  },
  "&.readAcceptBtn": {
    background: "#1F1F1F",
    lineHeight: "1.375rem",
    color: "#FFFFFF",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.7)"
    },
    "&.Mui-disabled": {
      color: "rgb(255, 255, 255)",
      backgroundColor: "#757575 !important"
    },
    [theme.breakpoints.up("sm")]: {
      width: "206px",
      height: "40px",
      borderRadius: "21px",
      padding: "9px 24px",
      lineHeight: "22px",
      alignSelf: "unset"
    }
  }
}));

export const StyledDialogTermsAndConditions = styled(Dialog)(({ theme }) => ({
  "& .container": {
    backgroundColor: "rgba(0,0,0,.3)"
  },
  "& .noTitlePaper": {
    width: "100%",
    minWidth: "auto",
    minHeight: "450px",
    borderRadius: "8px",
    boxShadow: "10px 10px 18px 0 rgba(0, 0, 0, 0.2)",
    backgroundColor: "#ffffff",
    maxWidth: "unset",
    [theme.breakpoints.between("sm", "md")]: {
      minHeight: "650px"
    },
    [theme.breakpoints.up("md")]: {
      width: "75%",
      height: "75%",
      minWidth: "780px",
      minHeight: "650px"
    }
  },
  "& .uploadModalCloseIcon": {
    position: "absolute",
    right: "16px",
    top: "16px",
    width: "16px",
    height: "16px",
    fill: "#525252",
    PointerEvent: "cursor",
    [theme.breakpoints.up("sm")]: {
      top: "20px",
      right: "18px"
    }
  }
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: "unset",
  height: "400px",
  overflowX: "hidden !important",
  "& div": {
    width: "100% !important"
  },
  [theme.breakpoints.up("sm")]: {
    padding: "8px 17px"
  },
  [theme.breakpoints.between("sm", "xl")]: {
    overflowX: "hidden !important"
  },
  [theme.breakpoints.up("md")]: {
    padding: "8px 17px"
  },
  "& .react-pdf__Page__canvas": {
    height: "100% !important",
    width: "100% !important",
    overflow: "hidden",
    [theme.breakpoints.between("sm", "xl")]: {
      width: "100% !important"
    }
  },
  "& .react-pdf__Page__textContent": {
    display: "none"
  },
  "&::-webkit-scrollbar": {
    display: "none"
  }
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: "20px",
  justifyContent: "center",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "0px 0px 20px 20px",
  "@media (max-width: 372px)": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  "& > * + *": {
    marginLeft: "20px"
  },
  "& .actionContainer": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "5px"
  },
  "& .agreeButton": {
    padding: "17px 40px",
    borderRadius: "100px",
    color: "#fff",
    fontWeight: "normal",
    margin: "0"
  },
  "& .scrollInstruction": {
    color: "#757575",
    fontSize: "12px"
  }
}));

export const StyledPdfPreview = styled(Document)(({ theme }) => ({
  width: "100%",
  height: "100%",
  overflowX: "hidden",
  overflowY: "auto",
  textAlign: "center",
  "& > div": {
    overflowX: "hidden !important",
    scrollbarWidth: "none", //Hide scrollbar in chrome/Edge/Firefox
    "&::-webkit-scrollbar": {
      display: "none"
    }
  }
}));

export const StakeholderConsentsWrapper = styled("div")(({ theme }) => ({
  "& .btnLoader": {
    width: "20px",
    height: "20px"
  }
}));

export const StyledRcifConfirmModal = styled(ConfirmDialog)(({ theme }) => ({
  "& .title": {
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    fontSize: "1.5rem",
    lineHeight: "1.75rem",
    letterSpacing: "var(--font-spacing-regular, 0rem)",
    padding: 0
  },
  "& .paper": {
    padding: "2.5rem",
    height: "min-content"
  },
  "& .MuiDialogContent-root": {
    padding: 0,
    margin: "1.5rem 0 2rem",
    "& p": {
      margin: 0,
      marginBottom: "0.5rem",
      color: "var(--Bau-Text-Primary-On-Light, #1F1F1F)",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "1.5rem",
      letterSpacing: "var(--font-spacing-regular, 0rem)"
    }
  },
  "& .divider": {
    display: "none"
  },
  "& .MuiDialogActions-root": {
    padding: 0
  },
  "& .MuiButton-root": {
    fontSize: "0.875rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem"
    }
  }
}));

export const StyledROinviteEfrSuccessScreen = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2.5rem",
  "& .roInviteEfrSuccessWrapper": {
    display: "flex",
    maxWidth: "49.25rem",
    padding: "2rem",
    flexDirection: "column",
    alignItems: "center",
    gap: "1.5rem",
    [theme.breakpoints.up("sm")]: {
      padding: "2.5rem",
      gap: "2.5rem",
      borderRadius: "0.625rem",
      background: "#FFF",
      boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.10)"
    }
  },
  "& .title": {
    color: "#1F1F1F",
    textAlign: "center",
    fontSize: "1.5rem",
    fontWeight: 500,
    lineHeight: "normal",
    letterSpacing: "0",
    margin: 0,
    marginBottom: "1rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem",
      lineHeight: "2.25rem"
    }
  },
  "& .description": {
    margin: 0,
    color: "#757575",
    textAlign: "center",
    fontSize: "1.25rem",
    fontWeight: 400,
    lineHeight: "1.75rem"
  }
}));
